import progressbar from 'chimera/all/store/progressbar'

export default progressbar
